/**
 * @param color
 * @returns
 */
export const isHexColor = (color: string): boolean => {
  const hexRegex = /^#(?:[0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/;
  return hexRegex.test(color);
};